export default __webpack_public_path__ + "static/media/TourGuidePage_06.7cafb039.jpg";